export default "__VITE_ASSET__BdQqjNGF__"